import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator, MatDialog, MatDialogConfig } from '@angular/material';
import { ClientService } from 'src/app/shared/services/client.service';
//import { ToastrService } from 'ngx-toastr';
//import { NotificationService } from 'src/app/shared/services/notification.service';
import { ClientDetailModel, ClientModel } from 'src/app/shared/models/client.model';
import { ClientDetailComponent } from '../client-detail/client-detail.component';
import * as XLSX from 'xlsx';
import { formatDate } from '@angular/common';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.css']
})
export class ClientListComponent implements OnInit {

  thisData : MatTableDataSource<any>;
  displayColumn : string[]= ['fullName', 'email', 'phone','company', 'countryCode', 'actions'];
  fileName : string;
  @ViewChild(MatSort, { static: false }) sort : MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator : MatPaginator;
  searchKey : string;
  @Input() mode : boolean;
  @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();

 dialogConfig = new MatDialogConfig();

  constructor(
    private service : ClientService,
    public userService : UserService,
    //private toastr : ToastrService,
    private dialog : MatDialog,
   // private notificationService: NotificationService,
    private gnotify : GlobalNotification ) {

      console.log("ClientListComponent : mode = " + this.mode);

      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";
      this.dialogConfig.minWidth = "400px";
      this.dialogConfig.maxWidth = "700px";
    }

  ngOnInit() {
    this.refreshList();
  }
  populateForm(item : ClientModel){
    this.service.formData  = Object.assign({}, item);
  }

  onDelete(id)
  {
    console.log("onDelete : " + id);

    if(!confirm("Are you sure to delete this customer?")) return;

    this.service.deleteData(id).subscribe(
      res=>{
        ////this.toastr.warning("Submitted successfully", "Customer Delete");
        this.gnotify.showSnackBar('Customer Delete', 'Submitted successfully', "warning");
        this.searchKey = "";
        this.refreshList();
      },
      err=>{
        console.log(err);
        ////this.toastr.error("Fail to Submit<br />This customer may be tied up with any data.",
        ////"Customer Delete", {enableHtml:true});
        this.gnotify.showSnackBar('Customer Delete', 'Fail to Submit. This customer may be tied up with any data.', "error");
      }
    );
  }

  refreshList()
  {
    this.service.getList().subscribe(
      res => {
        let array = res as ClientDetailModel[];
        this.thisData = new MatTableDataSource(array);
        this.thisData.sort = this.sort;
        this.thisData.paginator = this.paginator;

        console.log("refreshList : " + this.thisData.data.length);
        this.applyFilter()
       },
       err =>{
         console.log(err);
       }
    );

  }

  onSearchClear()
  {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter()
  {

    if(this.searchKey == null) return;
    console.log("applyFilter");
    this.thisData.filter = this.searchKey.trim().toLowerCase();
  }

  onCreate()
  {
    this.service.initializeFormGroup();

    this.dialogConfig.data = {
      result : false,
      data : null
    };

    let dialogRef = this.dialog.open(ClientDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();

      }

    });
  }

  onEdit(row){
    this.service.populateForm(row);
    /*
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "60%";*/
    this.dialogConfig.data = {
      result : false,
      data : row
    };

    let dialogRef = this.dialog.open(ClientDetailComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.refreshList();

      }

    });
  }
  onSelect(row : any)
  {
    this.onSelected.emit(row);
  }
  onExportAsExcel()
  {
    var currentDate = formatDate(new Date(), 'yyyyMMddhhmmss', 'en-US');
    this.fileName = "customers-" + currentDate + ".xlsx"
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet( this.thisData.filteredData);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }
}
